import { CustomerLoginResponse, LoginWithCodeRequest } from '@ca/common/types'
import useCartState from '@order/hooks/useCartState'
import { useOrderState } from '@order/hooks/useOrderState'
import { router } from 'expo-router'
import { useAvatarSessionEnd } from 'features/avatar/speech/useAvatarSession'
import Analytics from 'hooks/analytics/Analytics'
import useIntroStore from 'hooks/useIntroStore'
import useSession from 'hooks/useSession'

const useLoginCallback = (replace = true) => {
  const reset = useIntroStore((s) => s.reset)
  const setCustomer = useSession((s) => s.setCustomer)
  const resetOrder = useOrderState((s) => s.reset)
  const resetCart = useCartState((s) => s.reset)
  const { end: endAvatarSession } = useAvatarSessionEnd()

  const login = async (
    res: CustomerLoginResponse,
    req: LoginWithCodeRequest
  ) => {
    reset()
    resetOrder()
    resetCart()
    endAvatarSession()
    setCustomer(res)
    Analytics.trackLogin(req.strategy)
    Analytics.logEvent('customer_login', {
      strategy: req.strategy,
      customer_id: `${res.data.id}`,
      customer_ref: res.data.ref,
    })
    // Wait for the close animation to run
    requestAnimationFrame(() => {
      const customerPath = '/customer/home'

      if (!replace) {
        router.navigate(customerPath)
        return
      }
      router.replace(customerPath)
    })
  }

  return login
}

export default useLoginCallback
